import React from 'react';
import PropTypes from 'prop-types';

import {Step1} from './Step1';
import {Step2} from './Step2';
import {Step3} from './Step3';
import {Step4} from './Step4';

import { PROGRESS } from '../../constants/ProgressStates';

const progressSteps = {
    1: Step1,
    2: Step2,
    3: Step3,
    4: Step4
};

const CurrentStep = props => {
    const {
        hasUrl,
        isRelease,
        offlinePayment,
        onButtonClick,
        step,
        isCash
    } = props;

    // initialize all steps in collapsed, incomplete state
    let steps = [
        <Step1 isCash={isCash} />,
        <Step2 status={PROGRESS.INCOMPLETE} />,
        <Step3 isCash={isCash} status={PROGRESS.INCOMPLETE} offlinePayment={offlinePayment} />,
        <Step4 status={PROGRESS.INCOMPLETE} offlinePayment={offlinePayment} />
    ];

    if (!isCash) {
        steps = [
            <Step1 isCash={isCash} />,
            <Step2 status={PROGRESS.INCOMPLETE} />,
            <Step3 isCash={isCash} status={PROGRESS.INCOMPLETE} offlinePayment={offlinePayment} />
        ];
    }

    const stepProps = step === 1 ? {hasUrl, isRelease, onButtonClick} : {offlinePayment};

    const ActiveStep = progressSteps[step];
    steps[step - 1] = (
        <ActiveStep
            status={PROGRESS.ACTIVE}
            isCash={isCash}
            {...stepProps}
        />
    );

    // Mark previous steps as completed
    for (let i = 1; i < step; i++) {
        switch (i) {
            case 1:
                steps[0] = <Step1 isCash={isCash} status={PROGRESS.COMPLETE} isRelease={isRelease} />;
                break;
            case 2:
                steps[1] = <Step2 status={PROGRESS.COMPLETE} />;
                break;
            case 3:
                steps[2] = <Step3 isCash={isCash} status={PROGRESS.COMPLETE} offlinePayment={offlinePayment} />;
                break;
            case 4:
                steps[3] = <Step4 status={PROGRESS.COMPLETE} offlinePayment={offlinePayment} />;
                break;
            default:
                break;
        }
    }
    return steps;
};

CurrentStep.displayName = 'CurrentStep';

CurrentStep.propTypes = {
    hasUrl: PropTypes.bool,
    isRelease: PropTypes.bool,
    onButtonClick: PropTypes.func,
    step: PropTypes.number,
    offlinePayment: PropTypes.bool,
    isCash: PropTypes.bool
};

export default CurrentStep;
